package com.bikompanion.ui.watch

import com.bikompanion.domain.BikeStation

/** The station identity and last fresh snapshot carried by a notification click. */
data class StationNotificationTarget(
    val networkId: String,
    val stationId: String,
    val stationName: String = "",
    val station: BikeStation? = null,
)
